"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../assets/utils");

var CancellationPolicyStageDescription = function CancellationPolicyStageDescription(props) {
  var title = props.title,
      interval = props.interval,
      description = props.description,
      price = props.price;
  return /*#__PURE__*/_react["default"].createElement(StyledDescription, null, /*#__PURE__*/_react["default"].createElement(StyledTitleRow, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), /*#__PURE__*/_react["default"].createElement(StyledDate, null, (0, _utils.getReturnTitle)(price, interval))), /*#__PURE__*/_react["default"].createElement(StyledText, null, description));
};

var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDescription__StyledDescription",
  componentId: "sc-1cahloo-0"
})(["display:flex;flex-direction:column;"]);

var StyledTitleRow = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDescription__StyledTitleRow",
  componentId: "sc-1cahloo-1"
})(["display:flex;flex-direction:row;div + div{margin-left:4px;}"]);

var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDescription__StyledTitle",
  componentId: "sc-1cahloo-2"
})(["font-size:12px;line-height:16px;color:", ";font-weight:bold;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackBase;
});

var StyledDate = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDescription__StyledDate",
  componentId: "sc-1cahloo-3"
})(["font-size:12px;line-height:16px;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
});

var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDescription__StyledText",
  componentId: "sc-1cahloo-4"
})(["font-size:12px;line-height:16px;color:", ";max-width:222px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackBase;
});

var _default = /*#__PURE__*/_react["default"].memo(CancellationPolicyStageDescription);

exports["default"] = _default;